export default __webpack_public_path__ + "static/media/antivirussettingsoff.0443898b.png";